module.exports = __webpack_public_path__ + "static/media/7-th.8cd3195.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/audio/7-th.wav
// module id = wls5
// module chunks = 1